export const API_Urls = {
  loginApi: "/api/Authenticate/login",
  isTokenValid: "/api/Authenticate/IsTokenValid",
  impersonateUser: "/api/Authenticate/authenticatewithuserid",
};
